/* global module */

'use strict';

const { CLASSES } = require('../utils/globals');
const SELECTORS = {
    body: 'body',
    fitFinderForm: '.js-fitfinder-form',
    invalidField: '.is-invalid',
    inputFieldWrapper: '.js-field-wrapper',
    invalidFieldMessage: '.js-invalid-message',
    submitBtn: '.js-submit-btn',
    nextTabBtn: '.js-next-tab-btn',
    prevTabBtn: '.js-prev-tab-btn',
    firstTabBtn: '.js-first-tab-btn',
    pageSubTitle: '.js-sub-title',
    weightInput: '.js-weight-field-input',
    rangeWeight: '.js-weight-range',
    measurementCards: '.ff-tab',
    editFitBtn: '.js-edit-fit',
    saveFitBtn: '.js-save-fit',
    closeFitBtn: '.js-close-fit',
    fitContainer: '.js-fit-container',
    fitForm: '.js-fit-form',
    suitRadio: '.suit-radio',
    suggestedFitForm: '.js-suggestedfit-form',
    fitWrapper: '.js-fit-wrapper',
    saveFitButton: '.js-save-fit',
    isEditedFitField: '.js-edited',
    ffButtonGrp: '.ff-button-group',
    ffSelectGrp: '.ff-select-group',
    ffAgeWrapper: '.ff-age-wrapper',
    ffWeightWrapper: '.js-weight-wrapper',
    ffAgeInput: '.js-age-input',
    ffBdayInput: '.js-bday-input',
    ffContainer: '.ff-container',
    recapContainer: '.recap',
    suggestedFitContainer: '.js-suggestedfit-container',
    reviewEnteredMeasureMents: '.js-review-entered-measurements',
    openReviewMeasurementLink: '.js-close-review-measurement-link',
    closeReviewMeasurementBtn: '.js-close-review-measurement-btn',
    anonSuggestedEndnote: '.fitfinder-anon-suggested-endnote',
    redirectUrlInput: '.js-redirect-url'
};

var currentTab = 0;

/**
 * Initialize fir finder.
 * @returns {void}
 */
const init = () => {
    $(SELECTORS.measurementCards).first().show();

    $(SELECTORS.nextTabBtn).on('click', showCurrentTab);
    $(SELECTORS.prevTabBtn).on('click', showCurrentTab);
    $(SELECTORS.firstTabBtn).on('click', showFirstTab);
    $(SELECTORS.rangeWeight).on('change', updateWeightValue);
    $(SELECTORS.weightInput).on('focusout', updateRangeWeight);
    $(SELECTORS.ffBdayInput).on('change', handleBdayChange);

    // Fit suggestion page.
    $(SELECTORS.body).on('click', SELECTORS.editFitBtn, showFitForm);
    $(SELECTORS.body).on('click', SELECTORS.saveFitBtn, hideFitForm);
    $(SELECTORS.body).on('click', SELECTORS.closeFitBtn, hideFitForm);
    $(SELECTORS.body).on('click', SELECTORS.closeReviewMeasurementBtn, closeReviewMeasurement);
    $(SELECTORS.body).on('click', SELECTORS.openReviewMeasurementLink, openReviewMeasurement);

    let redirectUrl = $(SELECTORS.redirectUrlInput).val();
    if ($(SELECTORS.anonSuggestedEndnote).length > 0 && redirectUrl) {
        $(SELECTORS.anonSuggestedEndnote).find('a.f-button').attr('href', redirectUrl);
    }
};

const suggestedFit = () => {
    $(SELECTORS.saveFitBtn).on('click', editedFitForm);
}

/**
 * Hide or show the current tab.
 * @returns {void} editedFitForm
 */
const showCurrentTab = (e) => {
    e.preventDefault();
    const $btn = $(e.target);

    if ($btn.hasClass(SELECTORS.nextTabBtn.substring(1))) {
        if (currentTab === 0 && (!validateBday() || !validateAge())) {
            return;
        }

        if (currentTab === 1 && !validateWeight()) {
            return;
        }

        const $form = $(SELECTORS.fitFinderForm);
        let hasSelectedSuitFit = $(SELECTORS.suitRadio).is(':checked');
        if (hasSelectedSuitFit) {
            clearInvalidFields();
        } else {
            $form.trigger('submit');
        }


        // Check for any invalid fields on current card.
        let currentMeasurementTab = $(SELECTORS.measurementCards + ':eq(' + currentTab + ')');
        const invalidFields = currentMeasurementTab.find(SELECTORS.invalidField);
        if (invalidFields.length > 0) {
            return;
        }

        clearInvalidFields();
        fillRecapFields(currentMeasurementTab);
        currentTab++;

    } else {
        currentTab--;
    }

    showFitFinderTab();

};

const showFirstTab = (e) => {
    e.preventDefault();

    currentTab = 0;
    showFitFinderTab();
}

const showFitFinderTab = () => {
    $(SELECTORS.measurementCards).hide();
    $(SELECTORS.pageSubTitle).hide();
    $(SELECTORS.measurementCards + ':eq(' + currentTab + ')').show();
    $(SELECTORS.pageSubTitle + ':eq(' + currentTab + ')').show();
}

/**
 * Parse an MM/DD/YYYY (or M/D/YYYY) date string into a Date at local midnight.
 * @param {String} value - date string
 * @returns {Date|null} parsed date, or null when the string is not a valid date
 */
const parseDate = (value) => {
    if (!value) {
        return null;
    }

    const parts = value.split('/');
    if (parts.length !== 3) {
        return null;
    }

    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    if (isNaN(month) || isNaN(day) || isNaN(year)) {
        return null;
    }

    const date = new Date(year, month - 1, day);

    // Reject rolled-over dates (e.g. 13/45/2023) so only real calendar dates pass.
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        return null;
    }

    return date;
};

/**
 * Calculate the age in whole years for a given birth date.
 * @param {Date} birthDate - the birthday
 * @returns {Number} age in years
 */
const calculateAge = (birthDate) => {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
};

/**
 * Validate the birthday field is filled in with a proper date that satisfies the
 * field's `max` (minimum age) constraint. Errors are shown the same way as the
 * age input.
 * @returns {Boolean} if the birthday is valid
 */
const validateBday = () => {
    const $bday = $(SELECTORS.ffBdayInput);
    if (!$bday.length) {
        return true;
    }

    const $message = $bday.closest(SELECTORS.inputFieldWrapper).find(SELECTORS.invalidFieldMessage);

    $message.empty();
    $bday.removeClass(CLASSES.isInvalid);

    const value = $bday.val();
    if (!value) {
        $message.text($bday.data('missing-error'));
        $bday.addClass(CLASSES.isInvalid);
        return false;
    }

    const bdayDate = parseDate(value);

    // Unparseable / malformed date → format error.
    if (!bdayDate) {
        $message.text($bday.data('bday-format-error'));
        $bday.addClass(CLASSES.isInvalid);
        return false;
    }

    // Valid calendar date but younger than the minimum age (birthday later than
    // the max allowed date) → age-requirement error.
    const maxDate = parseDate($bday.attr('data-max-date'));
    if (maxDate && bdayDate > maxDate) {
        $message.text($bday.data('bday-validation-error'));
        $bday.addClass(CLASSES.isInvalid);
        return false;
    }

    return true;
};

/**
 * When a birthday is selected/entered, validate it and populate the age input
 * with the calculated age (clearing it when the birthday is invalid).
 * @returns {void}
 */
const handleBdayChange = () => {
    const $ageInput = $(SELECTORS.ffAgeInput);

    if (!validateBday()) {
        $ageInput.val('');
        return;
    }

    $ageInput.val(calculateAge(parseDate($(SELECTORS.ffBdayInput).val())));
};

/**
 * Validate user's age
 * @returns {Boolean} if age is valid
 */
const validateAge = () => {
    var isValid = true;

    if ($(SELECTORS.ffAgeInput).length && (!$(SELECTORS.ffAgeInput).val() || $(SELECTORS.ffAgeInput).val() === '')) {
        $(SELECTORS.ffAgeWrapper).find(SELECTORS.invalidFieldMessage).text($(SELECTORS.ffAgeInput).data('missing-error'));
        return false;
    }

    if (Number($(SELECTORS.ffAgeInput).val()) <= 15) {
        $(SELECTORS.ffAgeWrapper).find(SELECTORS.invalidFieldMessage).text($(SELECTORS.ffAgeInput).data('age-validation-error-min'));
        isValid = false;
    }

    if (Number($(SELECTORS.ffAgeInput).val()) > 89) {
        $(SELECTORS.ffAgeWrapper).find(SELECTORS.invalidFieldMessage).text($(SELECTORS.ffAgeInput).data('age-validation-error-max'));
        isValid = false;
    }

    return isValid;
};

/**
 * Validate user's weight
 * @returns {Boolean} if weight is valid
 */
const validateWeight = () => {
    var isValid = true;

    if ($(SELECTORS.weightInput).length && (!$(SELECTORS.weightInput).val() || $(SELECTORS.weightInput).val() === '')) {
        $(SELECTORS.ffWeightWrapper).find(SELECTORS.invalidFieldMessage).text($(SELECTORS.weightInput).data('missing-error'));
        return isValid = false;
    }

    let $weightField = $(SELECTORS.weightInput);

    let minWeight = $weightField.attr('min') || 97;
    let maxWeight = $weightField.attr('max') || 460;

    if (Number($(SELECTORS.weightInput).val()) < minWeight) {
        $(SELECTORS.ffWeightWrapper).find(SELECTORS.invalidFieldMessage).text($(SELECTORS.weightInput).data('range-error'));
        isValid = false;
    }

    if (Number($(SELECTORS.weightInput).val()) > maxWeight) {
        $(SELECTORS.ffWeightWrapper).find(SELECTORS.invalidFieldMessage).text($(SELECTORS.weightInput).data('range-error'));
        isValid = false;
    }

    return isValid;
};

const updateWeightValue = (e) => {
    const $rangeWeight = $(e.target);
    $(SELECTORS.weightInput).val($rangeWeight.val());
    $(SELECTORS.weightInput).trigger('focusout');
};

const updateRangeWeight = (e) => {
    const $inputWeight = $(e.target);
    $(SELECTORS.rangeWeight).val($inputWeight.val());
};

const showFitForm = (e) => {
    const $btn = $(e.target);
    $btn.closest(SELECTORS.fitWrapper).addClass('edit');
    $(SELECTORS.editFitBtn).attr('disabled', true);
};

const hideFitForm = (e) => {
    const $btn = $(e.target);

    $btn.closest(SELECTORS.fitWrapper).removeClass('edit');
    $(SELECTORS.editFitBtn).attr('disabled', false);
};

const editedFitForm = (e) => {
    const $btn = $(e.target);

    const $selects = $btn.parents(SELECTORS.ffButtonGrp)
        .siblings(SELECTORS.ffSelectGrp)
        .find('select');

    $selects.each((i, select) => {
        const $select = $(select);
        let selector = '.js-' + $select.attr('id');

        if ($select.attr('id') === 'vest-size') {
            $(selector).text($select.find('option:selected').text());
        } else {
            $(selector).text($select.val());
        }
    });

    // Update flag to edited.
    $(SELECTORS.isEditedFitField).val(true);

    let $suggestedFitForm = $(SELECTORS.suggestedFitForm);

    $.spinner().start();
    $.ajax({
        url: $suggestedFitForm.attr('action'),
        method: 'POST',
        data: $suggestedFitForm.serialize(),
        success: function (response) {
            if (response.message) {
                let alert = $('<div/>')
                    .addClass('alert alert-success text-center')
                    .text(response.message)
                    .hide()
                    .fadeIn();
                $(SELECTORS.ffContainer).prepend(alert);

                setTimeout(function () {
                    alert.fadeOut().remove();
                }, 3000)
            }

            if ($(SELECTORS.anonSuggestedEndnote).length > 0) {
                if (response.redirectUrl) {
                    $(SELECTORS.anonSuggestedEndnote).find('a.f-button').attr('href', response.redirectUrl);
                }
            } else {
                if (response.redirectUrl) {
                    window.location = response.redirectUrl;
                }
            }

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
};

const clearInvalidFields = () => {
    $(SELECTORS.invalidField).removeClass(CLASSES.isInvalid);
    $(SELECTORS.invalidFieldMessage).empty();
}

const fillRecapFields = (currentMeasurementTab) => {
    let $recapContainer = $(SELECTORS.recapContainer);
    let fields = $(currentMeasurementTab).find('input, select');
    fields.each((i, e) => {
        let $element = $(e);
        let id = $element.attr('id');
        let val = $element.val();
        let recapField = $recapContainer.find('.js-' + id);
        let recapMissingValue = $element.data('recap-value-missing');
        let recapSuffix = $recapContainer.find('.js-' + id + '--suffix');
        recapSuffix.addClass(CLASSES.hide);

        if ($element.attr('type') === 'radio') {
            if ($element.prop('checked')) {
                recapField.removeClass(CLASSES.hide)
                recapField.siblings('span').addClass(CLASSES.hide);
                recapSuffix.removeClass(CLASSES.hide);
            }
        } else {
            recapField.text(val);

            if (val) {
                recapSuffix.removeClass(CLASSES.hide);
            } else if (recapMissingValue) {
                recapField.text(recapMissingValue);
            }
        }
    });
}

const closeReviewMeasurement = () => {
    $(SELECTORS.suggestedFitContainer).removeClass(CLASSES.hide);
    $(SELECTORS.reviewEnteredMeasureMents).addClass(CLASSES.hide);
}

const openReviewMeasurement = (e) => {
    e.preventDefault();

    $(SELECTORS.reviewEnteredMeasureMents).removeClass(CLASSES.hide);
    $(SELECTORS.suggestedFitContainer).addClass(CLASSES.hide);
}


module.exports = {
    init,
    suggestedFit
};